import React, { useState } from "react";
import styles from "./DemoRegistration.module.css";

function DemoRegistration() {
  const [formData, setFormData] = useState({
    schoolName: "",
    email: "",
    contact: "",
    principalName: "",
    contactPerson: "",
    contactPersonNo: "",
    address: "",
    state: "",
    city: "",
    pinCode: "",
    demoDate: "",
    startTime: "",
    endTime: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [demoCode, setDemoCode] = useState("");

const getCurrentTime = () => {
  const now = new Date();

  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
};


const handleChange = (e) => {
  const { name, value } = e.target;

  // Contact fields: only numbers allowed
  if (name === "contact" || name === "contactPersonNo") {
    const onlyNumbers = value.replace(/\D/g, "");

    setFormData({
      ...formData,
      [name]: onlyNumbers,
    });

    return;
  }

  // Pin Code: only numbers allowed
  if (name === "pinCode") {
    const onlyNumbers = value.replace(/\D/g, "");

    setFormData({
      ...formData,
      [name]: onlyNumbers,
    });

    return;
  }

  // Demo Date
  if (name === "demoDate") {
    const today = new Date().toISOString().split("T")[0];
    if (value < today) {
      alert("Please select today or a future date.");
      return;
    }
    setFormData({
      ...formData,
      demoDate: value,
      startTime: "",
      endTime: "",
    });

    return;
  }
 // Start Time
  if (name === "startTime") {
    const today = new Date().toISOString().split("T")[0];
    const currentTime = getCurrentTime();
    
    if (formData.demoDate === today && value < currentTime) {
      alert("Please select a future time.");
      return;
    }

    
    if (formData.endTime && value >= formData.endTime) {
      alert("Start time must be before end time.");
      return;
    }

    setFormData({
      ...formData,
      startTime: value,
    });

    return;
  }

  // End Time
  if (name === "endTime") {
    const today = new Date().toISOString().split("T")[0];
    const currentTime = getCurrentTime();

    
    if (formData.demoDate === today && value < currentTime) {
      alert("Please select a future time.");
      return;
    }

    
    if (formData.startTime && value <= formData.startTime) {
      alert("End time must be after start time.");
      return;
    }

    setFormData({
      ...formData,
      endTime: value,
    });

    return;
  }

  // Other fields
  setFormData({
    ...formData,
    [name]: value,
  });
};
const handleSubmit = async (e) => {
  e.preventDefault();
  const payload =  {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    schoolName: formData.schoolName,
                    email: formData.email,
                    contactNo: formData.contact,
                    principalName: formData.principalName,
                    contactPerson: formData.contactPerson,
                    contactPersonNo: formData.contactPersonNo,
                    address: formData.address,
                    state: formData.state,
                    city: formData.city,
                    pinCode: formData.pinCode,
                    demoDate: formData.demoDate,
                    startTime: formData.startTime,
                    endTime: formData.endTime,
                  }),
                }

  try {
    const response = await fetch(
      "https://swaadhyayan.com/swaBlog/api/demoBook/demoBook.php",payload);

    const result = await response.json();
    console.log("API Response:", result);
    if (result.status === "success") {
      setDemoCode(result.bookingCode);
      // Success popup show
      setShowPopup(true);
    } else {
      alert(result.message || "Demo registration failed");
    }
  } catch (error) {
    console.error("API Error:", error);
    alert("Something went wrong. Please try again.");
  }
};
  const closePopup = () => {
    setShowPopup(false);
          setFormData({
            schoolName: "",
            email: "",
            contact: "",
            principalName: "",
            contactPerson: "",
            contactPersonNo: "",
            address: "",
            state: "",
            city: "",
            pinCode: "",
            demoDate: "",
            startTime: "",
            endTime: "",
          });
  };

  return (
    <div className={styles.demoContainer}>
      <div className={styles.formWrapper}>
        <h2>Book a Demo</h2>
        <p className={styles.subtitle}>
          Register your school/institute for a demo
        </p>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGrid}>
            {/* School Name */}
            <div className={styles.formGroup}>
              <label>
                School / Institute Name
                <span>*</span>
              </label>
              <input
                type="text"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                placeholder="Enter School/Institute Name"
                required
              />
            </div>

            {/* Email */}
            <div className={styles.formGroup}>
              <label>
                Email
                <span>*</span>
              </label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter Email Address"
                required
              />
            </div>

            {/* Contact */}
            <div className={styles.formGroup}>
              <label>
                Contact
                <span>*</span>
              </label>

              <input
                type="tel"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                placeholder="Enter Contact Number"
                maxLength="10"
                pattern="[0-9]{10}"
                inputMode="numeric"
                required
              />
            </div>
            {/* Principal */}
            <div className={styles.formGroup}>
              <label>
                Principal Name
                <span>*</span>
              </label>

              <input
                type="text"
                name="principalName"
                value={formData.principalName}
                onChange={handleChange}
                placeholder="Enter Principal Name"
                required
              />
            </div>

            {/* Contact Person */}
            <div className={styles.formGroup}>
              <label>
                Contact Person (at School)
                <span>*</span>
              </label>

              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                placeholder="Enter Contact Person Name"
                required
              />
            </div>

            {/* Contact Person No */}
            <div className={styles.formGroup}>
              <label>
                Contact Person No.
                <span>*</span>
              </label>

              <input
                type="text"
                name="contactPersonNo"
                value={formData.contactPersonNo}
                onChange={handleChange}
                maxLength="10"
                pattern="[0-9]{10}"
                placeholder="Enter Contact Person No"
                required
              />
            </div>

            {/* Address */}
            <div className={`${styles.formGroup} ${styles.fullWidth}`}>
              <label>
                Address
                <span>*</span>
              </label>

              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter School / Institute Address"
                rows="3"
                required
              />
            </div>

            {/* State */}
            <div className={styles.formGroup}>
              <label>
                State
                <span>*</span>
              </label>

              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter State"
                required
              />
            </div>

            {/* City */}
            <div className={styles.formGroup}>
              <label>
                City
                <span>*</span>
              </label>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter City"
                required
              />
            </div>

            {/* Pin Code */}
            <div className={styles.formGroup}>
              <label>
                Pin Code
                <span>*</span>
              </label>

              <input
                type="text"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                placeholder="Enter Pin Code"
                maxLength="6"
                required
              />
            </div>

            {/* Demo Date */}
            <div className={styles.formGroup}>
              <label>
                Date for Demo
                <span>*</span>
              </label>
              <input
                  type="date"
                  name="demoDate"
                  value={formData.demoDate}
                  onChange={handleChange}
                  min={new Date().toISOString().split("T")[0]}
                  required
                />
            </div>

            {/* Start Time */}
            <div className={styles.formGroup}>
              <label>
                Time Slot From
                <span>*</span>
              </label>

              <input
                  type="time"
                  name="startTime"
                  value={formData.startTime}
                  onChange={handleChange}
                  min={
                    formData.demoDate === new Date().toISOString().split("T")[0]
                      ? getCurrentTime()
                      : undefined
                  }
                  required
                />
            </div>

            {/* End Time */}
            <div className={styles.formGroup}>
              <label>
                Time Slot To
                <span>*</span>
              </label>

              <input
                type="time"
                name="endTime"
                value={formData.endTime}
                onChange={handleChange}
                min={
                  formData.demoDate === new Date().toISOString().split("T")[0]
                    ? getCurrentTime()
                    : formData.startTime || undefined
                }
                required
              />
            </div>
          </div>

          <div className={styles.buttonWrapper}>
            <button type="submit">Send Request</button>
          </div>
        </form>
      </div>

      {/* SUCCESS POPUP */}
      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <div className={styles.successIcon}>✓</div>
            <h3>Request Successfully Registered</h3>
              <p>Your request has been successfully registered.</p>
            <div className={styles.demoCodeBox}>
                <span>Demo Code</span>
                <strong>{demoCode}</strong>
            </div>
            <button className={styles.okButton} onClick={closePopup}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DemoRegistration;
